import React, { useContext, useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import './Lesson.css';
import LeftColumn from '../MainPage/LeftColumn/LeftColumn';
import HorizontalTree from '../App/Common/HorizontalTree/HorizontalTree';

import api from '../../Utils/Api';

import { CurrentUserContext } from '../../Contexts/CurrentUserContext';
import { JourneyContext } from '../../Contexts/JourneyContext';
import TaskCard from '../App/Common/Cards/TaskCard/TaskCard';
import OpenedBlock from '../App/Common/BlocksWithCards/OpenedBlock/OpenedBlock';
import LockedTaskCard from '../App/Common/Cards/LockedTaskCard/LockedTaskCard';
import Calendar from '../Calendar/Calendar';

const Lesson = ({ courses }) => {
    const { token, user } = useContext(CurrentUserContext);
    const { currentPlace, breadCrumbs, setBreadCrumbs, setCurrentPlace } =
    useContext(JourneyContext);
    const [room, setRoom] = useState(0);
    let params = useParams();
    let selectedLessonId = parseInt(params.id);

    const [lesson, setLesson] = useState(undefined);

    useEffect(() => {
        api
            .getLesson(token, selectedLessonId)
            .then((res) => {
                // console.log(res);
                const filteredSteps = res.steps.filter(step => step.type !== 'videofile');

                const updatedRes = {
                  ...res,
                  steps: filteredSteps
                };
              
                setLesson(updatedRes);
                // setLesson(res);
                setBreadCrumbs(res.parents);
                setCurrentPlace(res.parents.slice(-1)[0]);
            })
            .catch((e) => {
                console.log(e);
            });
            return () => {
                setBreadCrumbs([]);
            };
    }, []);

    useEffect(() => {
        let teacherId = '0';
        let title = 'Урок';
        if (user && lesson) {
            let confs = lesson.steps.filter((les) => les.conference);
            if (confs.length > 0) {
                teacherId = confs[0].conference.password;
                title = confs[0].conference.title;
            }
            api
                .getConferenceRoom(
                    token,
                    selectedLessonId + user.user_id,
                    user.name,
                    parseInt(teacherId),
                    title
                )
                .then((res) => {
                    setRoom(res);
                })
                .catch((e) => {
                    console.log(e);
                });
        }
    }, [user, lesson]);

    const getTime = (date) => {
        const fullDate = new Date(date);
        const h = fullDate.getHours();
        const m = fullDate.getMinutes();
        //console.log(h, m);
        return `${h.toString().padStart(2, '0')} : ${m.toString().padStart(2, '0')}`;
    };
    const getDate = (date) => {
        let newDate = new Date(date);
        // console.log(newDate)
        const d = newDate.getDate();
        const m = newDate.getMonth();
        const y = newDate.getFullYear();
        return `${d.toString().padStart(2, '0')}.${(m + 1).toString().padStart(2, '0')}`;
    };
    //console.log(lesson);
    const [tab, setTab] = useState(false)
    const [titleTag, setTitle] = useState('')
    const handleOpenTab = (title) => {
        if (title === 'Все курсы') {
            setTab(false)
            setTitle('_courses')
        } else if (title === 'Календарь') {
            setTab(true)
            setTitle('_calendar') 
        }
      }
    return (
        lesson && (
            <div className='currentTasks__wrapper'>
                 <div className='tab__wrap'>
              <div className={'tab__btn' + (titleTag ? titleTag === '_courses' : 'true')} onClick={() => handleOpenTab('Все курсы')}>Материалы</div>
              {/* <div className={'tab__btn' + (titleTag ? titleTag === '_calendar' : 'false')} onClick={() => handleOpenTab('Календарь')}>Календарь</div> */}
            </div>
             <div className = 'currentTasks__container openedBlock__container' >
            {tab && <div className='courses__calendar'><Calendar></Calendar></div>}
            {!tab && <div style={{width: '100%'}}>
            <div className = 'currentTasks__center' >
            <div className = 'lesson__top' >
            {/* <HorizontalTree id = { selectedLessonId } */}
            {/* type = { 'lesson' } */}
            {/* /> */}

            <OpenedBlock title = { lesson.title } >
            <div className = 'lesson__cards' > {
                lesson.steps.map((i, index) =>
                    i.test?.is_blocked || i.test?.is_blocked === null ? ( <            LockedTaskCard key = { index }
                        description = {
                            i.test ?
                            i.test.title :
                                i.html ?
                                i.html.title :
                                i.exercise ?
                                i.exercise.title :
                                i.conference ?
                                i.conference.title :
                                'Название'
                        }
                        progress = {
                            i.test && i.test.attempts_left > 0 ?
                            `${i.test.attempts_left} попытки` :
                                undefined
                        }
                        deadline = {
                            i.test && i.test.days_left ?
                            `${i.test.days_left} дней` :
                                undefined
                        }
                        />
                    ) : ( <            TaskCard key = { index }
                        // title={i.title}
                        target = { i.conference ? '_blank' : '_self' }
                        description = {
                            i.test ?
                            i.test.title :
                                i.html ?
                                i.html.title :
                                i.exercise ?
                                i.exercise.title :
                                i.conference ?
                                i.conference.title :
                                'Название'
                        }
                        progress = {
                            i.test && i.test.attempts_left > 0 ?
                            `${i.test.attempts_left} попытки` :
                                undefined
                        }
                        deadline = {
                            i.test && i.test.days_left ?
                            `${i.test.days_left} дней` :
                                undefined
                        }
                        link = {!i.conference ? `/resource/${i.id}` : `${room}` }
                        type = {
                            i.test ?
                            'Тест' :
                                i.exercise ?
                                'Упражнение' :
                                i.conference ?
                                'Видеоурок' :
                                'Материал'
                        }
                        confTime = {
                            i.conference ?
                            getTime(i.conference.start_time) :
                                undefined
                        }
                        confDate = {
                            i.conference ?
                            getDate(i.conference.start_time) :
                                undefined
                        }
                        />
                    )
                )
            } </div> </OpenedBlock> </div> </div> </div>}
            </div>
            </div>

        )
    );
};
export default Lesson;